import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ImpersonationBanner } from '@/components/layout/ImpersonationBanner';
import { Sidebar } from '@/components/layout/Sidebar';
import { Topbar } from '@/components/layout/Topbar';
import { cn } from '@/lib/utils';
import { usePageMeta } from '@/lib/seo';
import { CustomerJuni } from '@/modules/juni/CustomerJuni';

export function AppShell() {
  usePageMeta({
    title: 'Dashboard',
    description: 'Automation, monitoring and backups for your servers.',
    noindex: true,
  });

  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="aurora-bg min-h-screen">
      <Sidebar open={sidebarOpen} />

      {sidebarOpen && (
        <button
          type="button"
          aria-label="Close navigation"
          className="fixed inset-0 z-20 bg-background/60 backdrop-blur-sm lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className={cn('flex min-h-screen flex-col lg:pl-64')}>
        {/* Above the topbar, and outside the scrolling main area, so it cannot be scrolled
            past. Forgetting whose account you are looking at is the failure mode. */}
        <ImpersonationBanner />
        <Topbar onToggleSidebar={() => setSidebarOpen((v) => !v)} />
        <main className="flex-1 animate-fade-in-up p-4 lg:p-8">
          <Outlet />
        </main>
      </div>

      <CustomerJuni />
    </div>
  );
}
